import React from 'react';
import { useEventSummaries } from './hooks/useSwampData';
import { BannerHeader } from './components/BannerHeader';
import { TrophyGrid } from './components/TrophyGrid';
import { BACKGROUND_PATTERN_SRC } from './assets';
import './styles/SwampTavern.css';

export function SwampTavern() {
   const { summaries, loading, error } = useEventSummaries();

   return (
      <div
         className="swamp-window"
         style={{ backgroundImage: `url(${BACKGROUND_PATTERN_SRC})` }}
      >
         <BannerHeader title="Tribe Battles" backTo="/" />

         <main className="swamp-window__body">
            {loading && <p className="swamp-status">Loading events...</p>}
            {error && <p className="swamp-status swamp-status--error">{error}</p>}
            {!loading && !error && <TrophyGrid events={summaries} />}
         </main>
      </div>
   );
}
